import { resolveApiUrl } from "../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/checkout/multi/summary/selectaddress");

export function sendData(addressId: string, temporary?: boolean): Promise<Response> {
  if (temporary !== undefined) {
    return fetch(`${apiUrl}/${temporary}/${addressId}`, {
      credentials: "same-origin", // include, omit
      mode: "cors", // no-cors, same-origin
      referrer: "no-referrer", // client
    });
  } else {
    return fetch(`${apiUrl}?selectedAddressCode=${addressId}`, {
      credentials: "same-origin", // include, omit
      mode: "cors", // no-cors, same-origin
      referrer: "no-referrer", // client
    });
  }
}
